import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  TextField,
  Icon,
  FormControl,
  Grid,
  MenuItem,
  InputLabel,
  Select,
  FormHelperText,
  IconButton,
  Grow,
  Slide,
} from "@material-ui/core";
import CardBody from "../../../common/components/Card/CardBody";
import { DropzoneArea } from "material-ui-dropzone";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Upload from "../../../common/components/Upload";
import { LOCALE } from "../../../properties/Locale";
import { ProfessionalPracticeRepository } from "./ProfessionalPracticeRepository";
import { professionalPracticeValidator } from "./ProfessionalPracticeValidator";

const useStyles = makeStyles(styles);

export default function ProfessionalPracticeComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [rerender, triggerRerender] = React.useState(false);
  const [btnDisabled, setBtnDisabled] = React.useState(false);

  const [
    professionalPracticeData,
    setProfessionalPracticeData,
  ] = React.useState([]);
  const [
    professionalPracticeFormErrors,
    setProfessionalPracticeFormErrors,
  ] = React.useState({});

  useEffect(() => {
    triggerRerender(!rerender);
  }, [professionalPracticeFormErrors]);

  useEffect(() => {
    ProfessionalPracticeRepository.getProfessionalPracticeRecords(
      props.vacancyAppId
    ).then((res) => {
      if (res.data.length > 0) setProfessionalPracticeData(res.data);
    });
  }, []);

  const addRow = () => {
    let data = professionalPracticeData;
    data.push({
      title: "",
      description: "",
      attachments: [],
    });
    setProfessionalPracticeData(data);
    setProfessionalPracticeFormErrors({});
    triggerRerender(!rerender);
  };

  const deleteRow = (index) => {
    let data = professionalPracticeData;
    data.splice(index, 1);
    setProfessionalPracticeData(data);
    setProfessionalPracticeFormErrors({});
    triggerRerender(!rerender);
  };

  const handleChange = (event, index, name) => {
    let data = professionalPracticeData;
    data[index][name] = event.target.value;
    setProfessionalPracticeData(data);
    triggerRerender(!rerender);
  };

  const handleClickNext = () => {
    setBtnDisabled(true);
    let data = professionalPracticeData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!professionalPracticeValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("next");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await professionalPracticeValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setProfessionalPracticeFormErrors(validationErrors);
    }
  };

  const handleClickPrev = () => {
    setBtnDisabled(true);
    let data = professionalPracticeData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!professionalPracticeValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("prev");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await professionalPracticeValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setProfessionalPracticeFormErrors(validationErrors);
    }
  };

  const saveData = (step) => {
    ProfessionalPracticeRepository.saveProfessionalPracticeRecords(
      props.vacancyAppId,
      professionalPracticeData
    ).then(
      (res) => {
        if (step === "next") {
          props.handleNextStep();
        } else {
          props.handlePreviousStep();
        }
      },
      (err) => {
        setBtnDisabled(false);
      }
    );
  };

  const addAttachments = (index, attachments) => {
    let data = professionalPracticeData;
    data[index].attachments = attachments;
    setProfessionalPracticeData(data);
  };

  return (
    <div>
      <Card>
        <CardHeader
          color="theme"
          style={{ padding: "8px", paddingLeft: "15px" }}
        >
          <Grid container>
            <Grid item xs={8}>
              {" "}
              <Typography>Список на докази за професионална пракса</Typography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}>
              {" "}
              {!props.disabled && (
                <Button
                  color="default"
                  variant="contained"
                  className={
                    professionalPracticeData.length == 0 ? "bounceButton" : ""
                  }
                  startIcon={<Icon>add_circle_outline</Icon>}
                  size="small"
                  aria-label="create"
                  style={{ float: "right" }}
                  onClick={addRow}
                >
                  Додади практика
                </Button>
              )}
            </Grid>
          </Grid>
        </CardHeader>
        <CardBody>
          <Table aria-label="groups table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  Реден Број
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  Наслов
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  Опис
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  Доказ
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  Акции
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {professionalPracticeData.length > 0 ? (
                professionalPracticeData.map((item, index) => (
                  <TableRow
                    key={index}
                    className={classes.tableBodyRow}
                    style={index % 2 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell className={classes.tableCell}>
                      {index + 1}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <TextField
                        value={item.title}
                        variant="outlined"
                        label="Наслов"
                        fullWidth={true}
                        disabled={props.disabled}
                        error={professionalPracticeFormErrors[index]?.title}
                        helperText={
                          professionalPracticeFormErrors[index]?.title?.message
                        }
                        size="small"
                        onChange={(e) => handleChange(e, index, "title")}
                      />
                    </TableCell>

                    <TableCell className={classes.tableCell}>
                      <TextField
                        disabled={props.disabled}
                        value={item.description}
                        variant="outlined"
                        fullWidth={true}
                        label="Опис"
                        error={
                          professionalPracticeFormErrors[index]?.description
                        }
                        helperText={
                          professionalPracticeFormErrors[index]?.description
                            ?.message
                        }
                        size="small"
                        onChange={(e) => handleChange(e, index, "description")}
                      />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormControl
                        disabled={props.disabled}
                        className={classes.formControl}
                        variant="outlined"
                        error={
                          professionalPracticeFormErrors[index] &&
                          professionalPracticeFormErrors[index]["attachments"]
                        }
                        size="small"
                      >
                        <Upload
                          vacancyAppDomain={"PROFESSIONAL_PRACTICE"}
                          vacancyAppId={props.vacancyAppId}
                          attachments={item.attachments}
                          onComponentClose={addAttachments}
                          rowIndex={index}
                          disabled={props.disabled}
                        />
                        <FormHelperText id="municipality-helper-text">
                          {professionalPracticeFormErrors[index] &&
                            professionalPracticeFormErrors[index]["attachments"]
                              ?.message}
                        </FormHelperText>{" "}
                      </FormControl>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <IconButton
                        disabled={props.disabled}
                        color="secondary"
                        size="small"
                        aria-label="delete"
                        onClick={() => deleteRow(index)}
                      >
                        <Icon>delete</Icon>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={12}>
                    <Icon style={{ color: "orange", verticalAlign: "bottom" }}>
                      warning
                    </Icon>{" "}
                    Немате додадени {" ПРОФЕСИОНАЛНИ ПРАКТИКИ".toLowerCase()}.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      {!props.disabled && (
        <div>
          <Button
            color="secondary"
            variant="contained"
            disabled={btnDisabled}
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            onClick={() => handleClickNext()}
          >
            {LOCALE.next}
          </Button>
          <Button
            style={{ marginRight: "5px", float: "right" }}
            color="secondary"
            variant="outlined"
            disabled={btnDisabled}
            size="small"
            onClick={() => handleClickPrev()}
          >
            {LOCALE.previous}
          </Button>
        </div>
      )}
    </div>
  );
}
